import React from "react";

const StyledMdParagraph = ({ children, fontColor }) => {
  return <p className={`text-md font-mulish ${fontColor}`}>{children}</p>;
};
export default StyledMdParagraph;
